import { Link, useLocation, useNavigate } from "react-router-dom";
import { iconMap } from "../../components/IconMap";
import { whiteLogo } from "../../assets/exports";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { LogOut, UserCog } from "lucide-react";
import { logout } from "../../slices/authSlice";
import React, { useState } from "react";
import SwitchProfileModal from "../../components/SwitchProfileModal";

export interface NavItem {
    name: string,
    icon: string,
    route: string,
}

export interface Props {
    data: NavItem[];
}

export const Sidebar: React.FC<Props> = ({
    data
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const userDetails = useAppSelector((state) => state.auth.user);
    const subscriptionDetails = useAppSelector((state) => state.subscription);

    const [openSwitchProfileModal, setOpenSwitchProfileModal] = useState<boolean>(false);
    // console.log("Subscription: ", subscriptionDetails);

    const dispatch = useAppDispatch();
    const { trial } = useAppSelector(
        (state) => state.subscription
    );

    return (
        <>
            <aside
                className="
                    hidden md:flex flex-col w-64 h-screen p-6 gap-4
                    backdrop-blur-xl bg-primary
                    border-r border-white/40 shadow-lg
                    fixed left-0 top-0 z-40
                "
            >

                <div className="flex flex-col gap-3 text-white justify-center items-center">
                    <p className="font-bold text-center">
                        {userDetails?.Business.name}
                    </p>
                    <img
                        src={userDetails?.Business.logo ?? "/icons/android-chrome-192x192.png"}
                        alt={`${userDetails?.Business.name} logo`}
                        className="rounded-full w-20 h-20 object-cover"
                    />
                    <div className="px-4 py-2 rounded-3xl"
                        style={{
                            backgroundColor: subscriptionDetails.style?.bgColor as string,
                            color: subscriptionDetails.style?.textColor as string
                        }}>
                        {subscriptionDetails.subscription?.packageName}
                    </div>
                    {trial &&
                        <div className="px-2 py-1 text-xs rounded-3xl bg-white text-primary">
                            Free Trial
                        </div>
                    }
                </div>

                <div className="w-full px-2 border border-white/50"></div>

                {/* Navigation */}
                <nav className="flex flex-col gap-2">
                    {data.map((item) => {
                        const isActive = location.pathname === item.route;

                        return (
                            <Link
                                key={item.route}
                                to={item.route}
                                className={`
                    flex items-center gap-3 py-3 px-4 rounded-lg transition
                    ${isActive
                                        ? "bg-white text-primary shadow"
                                        : "text-white hover:bg-blue-800"}
                    `}
                            >
                                <span>{iconMap[item.icon]}</span>
                                <span className="text-sm font-medium">{item.name}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div className="w-full px-2 border border-white/50"></div>


                <div
                    onClick={() => {
                        dispatch(logout())
                        navigate("/login")
                    }}
                    className="flex items-center gap-3 py-3 px-4 rounded-lg transition text-white hover:bg-blue-800 hover:cursor-pointer">
                    <span><LogOut size={22} /></span>
                    <span>Sign Out</span>
                </div>

                <div
                    onClick={() => setOpenSwitchProfileModal(true)}
                    className="flex items-center gap-3 py-3 px-4 rounded-lg transition text-white hover:bg-blue-800 hover:cursor-pointer">
                    <span><UserCog size={22} /></span>
                    <span>Switch Profile</span>
                </div>

                {/* Logo / Brand */}
                <div
                    className="text-2xl font-bold flex justify-center tracking-wide cursor-pointer hover:opacity-80 transition"
                    onClick={() => navigate("/?isAuthenticated=true")}
                >
                    <img
                        src={whiteLogo}
                        alt="StorePilot"
                        className="w-32 h-32"
                    />
                </div>
            </aside>

            <SwitchProfileModal
                isOpen={openSwitchProfileModal}
                onClose={() => setOpenSwitchProfileModal(false)}
            />
        </>
    );
}
